import $ from 'jquery';

function initRenewalSuccessModal() {
  // Check if we're on the homepage and have success parameters
  const urlParams = new URLSearchParams(window.location.search);
  const isSuccess = urlParams.get('housing_renewal_success') === '1';
  const name = urlParams.get('name');
  const expirationDate = urlParams.get('expiration_date');

  if (!isSuccess || !name || !expirationDate) {
    return;
  }

  const modal = $('#renewal-success-modal');
  const modalContainer = modal.find('.modal__container');
  const modalClose = modal.find('.modal__close');
  const body = $('body');

  // Populate modal content
  $('#renewal-success-name').text(decodeURIComponent(name));
  $('#renewal-success-expiration').text(decodeURIComponent(expirationDate));

  // Show modal
  function showModal() {
    modal.fadeIn();
    modalContainer.addClass('modal-active');
    body.addClass('disabled');
    
    // Clean URL by removing parameters
    const cleanUrl = window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);
  }

  // Close modal
  function closeModal() {
    modalClose.on('click', function() {
      modal.fadeOut();
      modalContainer.removeClass('modal-active');
      body.removeClass('disabled');
    });

    // Close on background click
    modal.on('click', function(e) {
      if ($(e.target).is(modal)) {
        modal.fadeOut();
        modalContainer.removeClass('modal-active');
        body.removeClass('disabled');
      }
    });

    // Close on ESC key
    $(document).on('keydown', function(e) {
      if (e.key === 'Escape' && modal.is(':visible')) {
        modal.fadeOut();
        modalContainer.removeClass('modal-active');
        body.removeClass('disabled');
      }
    });
  }

  // Initialize
  showModal();
  closeModal();
}

export {
  initRenewalSuccessModal,
}
